<div class="flex justify-content-between align-items-center gap-2 mt-4 w-full mb-4 flex-wrap">
    <span class="text-sm text-color-secondary"> Si no tienes vehículos, haz clic en <strong>"No poseo vehículos"</strong>. </span>

    <div class="flex gap-2 justify-content-end w-full sm:w-auto">
        @if(dataSource()){ @if ((dataSource().length) === 0) {
        <button miButton="secondary" class="ml-auto sm:ml-0" [miButtonIcon]="'solar:info-circle-broken'" (click)="noVehiculo()">
            No poseo vehículos
        </button>
        } @if (!indSinVehiculos() || (dataSource().length) === 0) {
        <button miButton="primary" class="ml-auto sm:ml-0" [miButtonIcon]="'solar:add-circle-broken'" (click)="openModalVehiculo()">
            Agregar
        </button>
        } }
    </div>
</div>
<div class="row mr-1 ml-1">
    <div class="col-12 error-gt">
        <span class="text-sm text-color-secondary"><b>Recuerda que debes agregar como mínimo un vehículo principal.</b></span>
    </div>
</div>

<!-- <div class="flex justify-content-between align-items-center gap-2 mt-4 w-full mb-4 flex-wrap">
    <span class="text-sm text-color-secondary"></span>
    <div class="flex gap-2 justify-content-end w-full sm:w-auto">
        <button miButton="primary" class="ml-auto sm:ml-0" [miButtonIcon]="'solar:add-circle-broken'" (click)="openModalVehiculo()">
            Agregar
        </button>
    </div>
</div> -->

@if (!isMobile()) {
<app-mi-table-simple
    [dataSource]="dataSource()"
    [columns]="columns()"
    [displayedColumns]="displayedColumns()"
    [edit]="true"
    [edit]="false"
    [delete]="false"
    [addActions]="addActions()"
    [filterColumns]="filterColumns()"
>
</app-mi-table-simple>
} @else { @if(dataSource()){ @if (dataSource().length === 0) {
<div class="flex flex-column align-items-center justify-content-center text-center p-4 border-round surface-card shadow-1 mb-3">
    <i class="iconify icon-32 mb-2 text-color-secondary" [attr.data-icon]="'solar:car-bold-duotone'"></i>
    <span class="text-lg font-bold mb-1">No hay vehículos registrados</span>
    <span class="text-sm text-color-secondary mb-3">Agrega tu primer vehículo para continuar.</span>
</div>
} @else {
<div class="grid">
    @for (vehiculo of dataSource(); track vehiculo.id) {
    <div class="col-12 mb-2">
        <article class="surface-card p-3 border-round shadow-1">
            <!-- Encabezado: Detalle principal + tipo -->
            <div class="flex justify-content-between align-items-start gap-2">
                @if(vehiculo.idTipoVehiculo != null && vehiculo.idTipoVehiculo != 0) {
                <div class="flex flex-column">
                    <div class="mt-1" [innerHTML]="vehiculo.detalle"></div>
                    <div class="mt-1"><strong>Tipo: </strong> {{ vehiculo.tipoVehiculoDescripcion }}</div>
                    <div class="mt-1"><strong>Propietario: </strong><span [innerHTML]="vehiculo.propietarioTag"></span></div>
                </div>
                } @else {
                <div class="flex flex-column">
                    <div class="mt-1" [innerHTML]="vehiculo.detalle"></div>
                </div>
                }
                <!-- Acciones -->
                <div class="flex flex-column gap-2">
                    @if(vehiculo.idTipoVehiculo !== null && vehiculo.idTipoVehiculo !== 0) {
                    <button
                        miButton="secondary"
                        [miButtonIcon]="'solar:pen-bold-duotone'"
                        class="mi-button-icon-only"
                        aria-label="Editar"
                        (click)="onEdit(vehiculo)"
                    ></button>
                    }
                    <button
                        miButton="danger"
                        [miButtonIcon]="'solar:trash-bin-trash-broken'"
                        class="mi-button-icon-only"
                        aria-label="Eliminar"
                        (click)="onDelete(vehiculo)"
                    ></button>
                </div>
            </div>
        </article>
    </div>
    }
</div>
} } }
